import { render, staticRenderFns } from "./consentForm.vue?vue&type=template&id=cb389ed6&scoped=true&"
import script from "./consentForm.vue?vue&type=script&lang=js&"
export * from "./consentForm.vue?vue&type=script&lang=js&"
import style0 from "./consentForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./consentForm.vue?vue&type=style&index=1&id=cb389ed6&lang=scss&scoped=true&"
import style2 from "./consentForm.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb389ed6",
  null
  
)

export default component.exports